// extracted by mini-css-extract-plugin
module.exports = {"cardMetric":"styles_cardMetric__vczSm","icon":"styles_icon__DB_Qy","title":"styles_title__g4gPu","value":"styles_value___9zd1","extra":"styles_extra__525A2"};